import { forwardRef, useEffect, useRef, useState } from "react";

const TECHS = [
  { name: "React", icon: "/tech-icons/react.svg" },
  { name: "Next.js", icon: "/tech-icons/nextjs.svg" },
  { name: "TypeScript", icon: "/tech-icons/typescript.svg" },
  { name: "JavaScript", icon: "/tech-icons/javascript.svg" },
  { name: "Tailwind CSS", icon: "/tech-icons/tailwindcss.svg" },
  { name: "Sass", icon: "/tech-icons/sass.svg" },
  { name: "Node.js", icon: "/tech-icons/nodejs.svg" },
  { name: "GraphQL", icon: "/tech-icons/graphql.svg" },
  { name: "PostgreSQL", icon: "/tech-icons/postgresql.svg" },
  { name: "MongoDB", icon: "/tech-icons/mongodb.svg" },
  { name: "Redis", icon: "/tech-icons/redis.svg" },
  { name: "Docker", icon: "/tech-icons/docker.svg" },
  { name: "Kubernetes", icon: "/tech-icons/kubernetes.svg" },
  { name: "Google Cloud", icon: "/tech-icons/googlecloud.svg" },
  { name: "Vite", icon: "/tech-icons/vitejs.svg" },
  { name: "Flutter", icon: "/tech-icons/flutter.svg" },
  { name: "Swift", icon: "/tech-icons/swift.svg" },
  { name: "Kotlin", icon: "/tech-icons/kotlin.svg" },
  { name: "Figma", icon: "/tech-icons/figma.svg" },
];

const PX_PER_SECOND = 55;

const TechItems = forwardRef<HTMLDivElement, { suffix: string; ariaHidden?: boolean }>(
  ({ suffix, ariaHidden }, ref) => (
    <div ref={ref} className="flex items-center shrink-0" aria-hidden={ariaHidden}>
      {TECHS.map((tech) => (
        <div key={`${tech.name}-${suffix}`} className="flex items-center gap-3 px-8 shrink-0 opacity-80 hover:opacity-100 transition-opacity">
          <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-white/90 shadow-sm shrink-0">
            <img src={tech.icon} alt={tech.name} width={24} height={24} className="w-6 h-6 object-contain" />
          </span>
          <span className="text-sm font-medium text-muted-foreground whitespace-nowrap">{tech.name}</span>
        </div>
      ))}
    </div>
  )
);
TechItems.displayName = "TechItems";

export function TechMarquee() {
  const setRef = useRef<HTMLDivElement>(null);
  const [style, setStyle] = useState<React.CSSProperties>({});

  useEffect(() => {
    const el = setRef.current;
    if (!el) return;

    const measure = () => {
      const width = el.getBoundingClientRect().width;
      if (width > 0) {
        setStyle({
          "--marquee-distance": `${width}px`,
          animationDuration: `${width / PX_PER_SECOND}s`,
        } as React.CSSProperties);
      }
    };

    measure();

    const ro = new ResizeObserver(measure);
    ro.observe(el);

    document.fonts?.ready?.then(measure).catch(() => {});

    return () => ro.disconnect();
  }, []);

  return (
    <div className="marquee-wrapper py-2">
      <div className="marquee-track" style={style}>
        <TechItems ref={setRef} suffix="a" />
        <TechItems suffix="b" ariaHidden />
      </div>
    </div>
  );
}
